import React from 'react';
import classNames from 'classnames';

import { prependSchemeIfMissing } from 'zoomforth_zfutils/url_validators.js';

import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import LanguageSelector from 'zoomforth_component_lib/translations_language_selector_container.jsx';

const HeaderContentsUi_ViewerVersion1 = ({
  pageTitle,
  headerTitleStyle,
  hasSecondaryLogo,
  hasSecondaryLogoUrl,
  secondaryLogoUrl,
  secondaryLogoStyle,
  secondaryLogoClassName,
  shouldShowLanguageSelectorInHeader,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange,
  onHeaderLogoClick
})=> (
  <div className="header-contents">

    <div
      className="header-thumbnail"
      onClick={onHeaderLogoClick}
    />

    {
      hasSecondaryLogo &&
        <div
          style={secondaryLogoStyle}
          className={secondaryLogoClassName}
          onClick={()=> {
            // we do this linking in JavaScript because we do not want to
            // break backwards compatability by introducing an anchor tag
            // when historically this has been a div with CSS background
            // properties. this may not be ideal but it is better than
            // ruining themes.
            if (hasSecondaryLogoUrl) {
              var win = window.open(prependSchemeIfMissing(secondaryLogoUrl), '_blank');
              win.focus();
            }
          }}
        />
    }

    {
      shouldShowLanguageSelectorInHeader &&
        <LanguageSelector
          currentIso={currentLanguageIso}
          defaultLanguageIso={defaultLanguageIso}
          appliedLanguages={appliedLanguages}
          onLanguageChange={onLanguageChange}
        />
    }

    <div className="header-text-box">
      <h1 className="header-title" style={headerTitleStyle}>
        {pageTitle}
      </h1>
    </div>

  </div>
);

const HeaderContentsUi_ViewerVersion2 = ({
  pageTitle,
  headerTitleStyle,
  hasSecondaryLogo,
  hasSecondaryLogoUrl,
  secondaryLogoUrl,
  secondaryLogoStyle,
  secondaryLogoClassName,
  shouldShowLanguageSelectorInHeader,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange,
})=> (
  <div className="header-contents">

    <a href="" className="header-thumbnail">
      <VisuallyHiddenSpan>
        Return home
      </VisuallyHiddenSpan>
    </a>

    {
      hasSecondaryLogo ?
        hasSecondaryLogoUrl ?
          <a
            target="_blank"
            href={secondaryLogoUrl}
            style={secondaryLogoStyle}
            className={classNames('zf-external-link', secondaryLogoClassName)}
          >
            <VisuallyHiddenSpan>
              Visit { secondaryLogoUrl }
            </VisuallyHiddenSpan>
            <span className="opens-in-external-view-wrapper">
              Opens in a new window
            </span>
          </a>
        :
          <div
            style={secondaryLogoStyle}
            className={secondaryLogoClassName}
          >
            <VisuallyHiddenSpan>
              Secondary logo alt text (TBD)
            </VisuallyHiddenSpan>
          </div>
      :
        null
    }

    {
      shouldShowLanguageSelectorInHeader &&
        <LanguageSelector
          currentIso={currentLanguageIso}
          defaultLanguageIso={defaultLanguageIso}
          appliedLanguages={appliedLanguages}
          onLanguageChange={onLanguageChange}
        />
    }

    <div className="header-text-box">
      <p className="header-title" style={headerTitleStyle}>
        {pageTitle}
      </p>
    </div>

  </div>
);

const HeaderContentsUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <HeaderContentsUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <HeaderContentsUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default HeaderContentsUi;
